<template>
  <div class="article-info">
    <!-- Post Date -->
    <div v-if="postDate" class="article-info__date">
      <span>
        {{ postDate | convertDate(getLang) }}
      </span>
    </div>
    <!-- ./Post Date -->

    <!-- Clock Icon -->
    <IconClock color-fill="#9797a6" />
    <!-- ./Clock Icon -->

    <!-- Post Date -->
    <div v-if="minRead" class="article-info__min-read">
      <span>
        {{ $i18n('blog.min-read', { minute: minRead }) }}
      </span>
    </div>
    <!-- ./Post Date -->
  </div>
</template>
<script>
import IconClock from '~/components/icons/IconClock.vue';
import moment from 'moment';

export default {
  name: 'DateAndMinRead',
  components: {
    IconClock,
  },
  filters: {
    convertDate(val, lang) {
      const date = new Date(val);
      return moment(date).locale(lang).format('MMMM, YYYY');
    },
  },
  props: {
    postDate: {
      type: String,
      default: null,
    },
    minRead: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    getLang() {
      return this.$store.state?.language?.lang || 'default';
    },
  },
};
</script>
<style lang="scss" scoped>
.article-info {
  @apply flex flex-row items-center gap-[10px];

  &__date,
  &__min-read {
    @apply text-[#9797a6] text-[13px];
  }
}
</style>
